import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { submitIdentityInfoForm as submitForm } from '../../actions/identityInfoForm';
import IdentityInfoForm from './IdentityInfoForm';

const mapStateToProps = () => ({
  tooltipMessagePhoneNumber: {
    id: 'Authentication.Login.Error.MissingCredentials', defaultMessage: '** Please enter all the required information to login',
  },
  tooltipMessageEmail: {
    id: 'Authentication.Login.Patient.Error.IncorrectCredentials', defaultMessage: '** Your credentials are incorrect. Please check your credentials and try again',
  },
  status: 'default',

  phoneNumber: {
    value: '',
    isDisabled: false,
    onChange: () => {},
    onFocus: () => {},
    status: 'default',
  },

  email: {
    value: '',
    isDisabled: false,
    onChange: () => {},
    onFocus: () => {},
    status: 'default',
  },
});

const mapDispatchToProps = {
  submitForm,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(IdentityInfoForm));
